import { createElement } from 'react';
import Lottie from 'lottie-react';

export default function SafeLottie(props: any) {
  let Component = Lottie;
  if (Component && typeof Component === 'object' && 'default' in Component) {
    Component = (Component as any).default;
  }
  return createElement(Component as any, props);
}